import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import Layout from './Components/Layout/Layout';
import Home from './Pages/Home';
import PostDetails from './Pages/ospemifene';
import PageNotFound from './Components/404/PageNotFound';
import AboutPage from './Pages/AboutPage';
import Ginecologia from './Pages/Ginecologia';
import MedicinaEstetica from './Pages/MedicinaEstetica';
import TrattamentiGinecologia from './Pages/TrattamentiGinecologia';
import ServiziEstetica from './Pages/ServiziEstetica';
import TrattamentiViso from './Pages/TrattamentiViso';
import CookiePolicy from './Pages/cookiePolicy';
import PrivacyPolicy from './Pages/privacyPolicy';

const App = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path='chi-sono' element={<AboutPage />} />
        <Route path='ginecologia' element={<Ginecologia />} />
        <Route path='medicina-estetica' element={<MedicinaEstetica />} />
        <Route path='trattamenti-ginecologia' element={<TrattamentiGinecologia />} />
        <Route path='servizi-estetica' element={<ServiziEstetica />} />
        <Route path='trattamenti-viso' element={<TrattamentiViso />} />
        <Route path='cookie-policy' element={<CookiePolicy />} />
        <Route path='privacy-policy' element={<PrivacyPolicy />} />
        <Route path='trattamenti-viso' element={<TrattamentiViso />} />
        <Route path="post/:postId" element={<PostDetails />} />
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default App;
